import { FC, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import useSchedule from "hooks/use-schedule";
import TableGrid from "components/Table";
import LoadingComponent from "components/Main/Loading";
import useScheduleSupplier from "hooks/Supplier/use-schedule-supplier";

interface DrawerExemploProps {
  isOpen: boolean;
  fecharDrawer: () => void;
  id: number;
}

const DrawerSupplierSchedule: FC<DrawerExemploProps> = ({
  isOpen,
  fecharDrawer,
  id,
}) => {
  const {
    getScheduleById,
    scheduleSelect,
    headers,
    idSelectDate,
    setSelectIdDate,
    loadingDrawer,
    cancelSchedule,
    handleSelectAll,
    setScheduleSelect,
    setSelecteds,
    selecteds,
    datesSchedulesModify,
  } = useScheduleSupplier();
  const bgLoading = useColorModeValue("white", "#111C44");
  const colorClose = useColorModeValue("black", "white");
  const colorSchemeButton = useColorModeValue("red", "red");

  useEffect(() => {
    if (isOpen) {
      setSelectIdDate(0);
      setSelecteds([]);
      getScheduleById(id);
    }
  }, [getScheduleById, id, isOpen, setScheduleSelect, setSelectIdDate]);
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={() => {
        fecharDrawer();
      }}
      closeOnOverlayClick={false}
      size={"md"}
    >
      <DrawerOverlay />
      <DrawerContent bg={bgLoading}>
        <DrawerCloseButton color={colorClose} />
        <DrawerBody mt={20} bg={bgLoading}>
          <VStack spacing={4}>
            <HStack spacing={4}>
              <Button
                colorScheme={colorSchemeButton}
                onClick={() => {
                  cancelSchedule();
                  setScheduleSelect([]);
                  fecharDrawer();
                }}
                variant={datesSchedulesModify.length > 0 ? "solid" : "outline"}
                isDisabled={selecteds.length < 1}
              >
                Cancelar Agendamento
              </Button>
            </HStack>
          </VStack>

          <VStack align="start" spacing={4} mt={4}>
            <Checkbox
              isChecked={
                loadingDrawer
                  ? false
                  : selecteds.length === scheduleSelect.length
              }
              onChange={handleSelectAll}
            >
              Selecionar tudo
            </Checkbox>
          </VStack>
          {loadingDrawer ? (
            <>
              <Box bg={bgLoading}>
                <LoadingComponent />
              </Box>
            </>
          ) : (
            <>
              <TableGrid
                id="schedule-supplier-drawer"
                headers={headers}
                data={scheduleSelect}
                itsSortable={true}
                entity="schedule-supplier-drawer"
                height={"420px"}
              />
            </>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerSupplierSchedule;
